export default "__VITE_ASSET__B4zh4yzE__"